<template>
  <div>
    <!-- Maintain the state to avoid unnecessary refetch of filters for the same project -->
    <!-- TODO: Optimize the global filters store to maintain a map/cache of project to filters -->
    <KeepAlive>
      <FiltersList v-if="mode == 'view'" @enter-edit-mode="mode = 'edit'"></FiltersList>
    </KeepAlive>
    <FiltersForm
      v-if="mode == 'edit'"
      :filter="undefined"
      :is-view-mode="false"
      @close-edit-mode="mode = 'view'"
    ></FiltersForm>
  </div>
</template>

<script setup lang="ts">
  import { onMounted, watch } from 'vue'
  import { ref } from 'vue'
  import { useRoute, useRouter } from 'vue-router'
  import FiltersForm from './FiltersForm.vue'
  import FiltersList from './FiltersList.vue'

  type Mode = 'view' | 'edit'
  const route = useRoute()
  const router = useRouter()
  const mode = ref<Mode>('view')

  onMounted(() => {
    if (route.query.mode === 'edit') mode.value = 'edit'
    else mode.value = 'view'
  })

  watch(mode, (newMode) => {
    router.push({
      query: {
        ...route.query,
        mode: newMode,
      },
    })
  })
</script>
